<template>
  <div class="nav-top-ad-box" v-if="ad && ad.indexTopOperation">
    <a :href="ad.indexTopOperation.link" class="ad-link" target="_blanck">
      <img :src="ad.indexTopOperation.img" alt class="ad-img">
    </a>
  </div>
</template>

<script>
export default {
  computed: {
    ad () {
      return this.$store.state.advertisement;
    }
  }
};
</script>

<style lang="less" scoped>
.nav-top-ad-box {
  width: 328px;
  height: 432px;
  .ad-link {
    display: block;
    width: 100%;
    height: 100%;
    position: relative;
    &::after {
      content: "广告";
      display: block;
      position: absolute;
      bottom: 0;
      right: 10px;
      background-color: rgba(77, 77, 77, 0.616);
      color: #fff;
      padding: 2px;
      padding-bottom: 0;
      font-size: 12px;
    }
    .ad-img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
